function inserted(el) {

  el.innerHTML = el.innerHTML.replace(/(?:\r\n|\r|\n)/g, '<br />')

}

export default {
  inserted,
}
